<template lang="pug">
div.drug-info--layout
  div.drug-table
    div.drug-table--row.drug-img--row
      div.drug-table--cell.drug-table--cell-head
        span 藥物圖片
        div (點擊放大)
      div.drug-table--cell
        img.drug-table--cell-image(
          :src="selectedDrug.drug_picture_1"
          v-if="selectedDrug.drug_picture_1 !== null"
          @click="showFocus"
        )
        span(v-if="selectedDrug.drug_picture_1 === null" style="margin: 0 60px;") 無照片
        img.drug-table--cell-image(
          :src="selectedDrug.drug_picture_2"
          v-if="selectedDrug.drug_picture_2 !== null"
          @click="showFocus"
        )
        span(v-if="selectedDrug.drug_picture_2 === null" style="margin: 0 60px;") 無照片
    div.drug-table--row.drug-desc--row
      div.drug-table--cell.drug-table--cell-head 
        span 學名
      div.drug-table--cell
        span {{selectedDrug.generic_name}}
    div.drug-table--row.drug-desc--row
      div.drug-table--cell.drug-table--cell-head 
        span 商品名
      div.drug-table--cell
        span(v-if="selectedDrug.product_name === null") 未設定
        span(v-else) {{selectedDrug.product_name}}
    div.drug-table--row.drug-desc--row
      div.drug-table--cell.drug-table--cell-head 
        span 藥碼 / 料位號
      div.drug-table--cell
        span {{selectedDrug.code}} / {{selectedDrug.CGMH_number}}
      
    div.drug-table--row(v-if="currentDrugInDevice === null")
      div.drug-table--cell.drug-table--cell-head 
        span 注意事項
      div.drug-table--cell
        span {{selectedDrug.note}}
    div.drug-table--row(v-if="currentDrugInDevice !== null")
      div.drug-table--cell.drug-table--cell-head 
        span 有效期限
      div.drug-table--cell
        span(:class="{'color-red': remainExpiredDays < 30}") {{currentDrugInDevice.expired_date}} 
          span(v-if="currentDrugInDeviceExpired") (已過期)
          span(v-if="remainExpiredDays < 30 && !currentDrugInDeviceExpired") (剩餘 {{remainExpiredDays}} 天過期)
    div.drug-table--row(v-if="currentDrugInDevice !== null")
      div.drug-table--cell.drug-table--cell-head 
        span 批號
      div.drug-table--cell
        span {{currentDrugInDevice.patch_number}}
    div.drug-table--row(v-if="currentDrugInDevice !== null && lastEvent")
      div.drug-table--cell.drug-table--cell-head 
        span 上次操作事件
      div.drug-table--cell
        span(v-if="Object.values(lastEvent).length === 0") 無
        span(v-else) {{ lastEvent.record_time | readabletime }} 由 {{ lastEvent.employee_name }} 進行 {{ lastEvent.event_type.event_name_zh }} 
          span(v-if="lastEvent.number1") (數量: {{lastEvent.number1}})
      //- span {{ lastEvent }}
  FocusModal(v-if="focusModalStatus" :message="foucsMessage" v-on:close="closeFocus")
</template>

<script>
import moment from 'moment';
import FocusModal from '../common/FocusModal';

export default {
  name: 'DrugInfo',
  data() {
    return {
      currentDrugInDeviceExpired: false,
      remainExpiredDays: 0,
      lastEvent: undefined,
      foucsMessage: '',
      focusModalStatus: false,
    };
  },
  components: {
    FocusModal,
  },
  methods: {
    showFocus(event) {
      console.log(event);
      const target = event.target;
      this.foucsMessage = target.outerHTML;
      this.focusModalStatus = true;
    },
    closeFocus() {
      this.foucsMessage = '';
      this.focusModalStatus = false;
    },
    checkDrugInDevicesIsExpired() {
      if (this.currentDrugInDevice !== null) {
        const expiredDate = moment(this.currentDrugInDevice.expired_date);
        const today = moment();
        if (expiredDate.diff(today, 'hours') > 0 && expiredDate.diff(today, 'hours') < 24) {
          this.remainExpiredDays = 1;
        } else {
          this.remainExpiredDays = expiredDate.diff(today, 'days');
        }
        if (this.remainExpiredDays < 0) {
          this.currentDrugInDeviceExpired = true;
        } else {
          this.currentDrugInDeviceExpired = false;
        }
      }
    },
    checkLastEvent() {
      if (this.currentDrugInDevice) {
        this.instance.get('/api/event/', {
          params: {
            drug_storage: this.currentDrugInDevice.id,
            last_event: true,
            per_page: 1,
          },
        })
        .then((res) => {
          this.lastEvent = res.data.results[0];
        });
      }
    },
  },
  created() {
    if (this.currentDrugInDevice !== null) {
      this.checkDrugInDevicesIsExpired();
      this.checkLastEvent();
    }
  },
  computed: {
    selectedDrug() {
      return this.$store.state.drug.selectedDrug;
    },
    currentDrugInDevice() {
      return this.$store.getters.currentDrugInDevice;
    },
    instance() {
      return this.$store.state.instance;
    },
  },
  filters: {
    readabletime(val) {
      if (val !== null || val !== undefined) {
        const time = moment(val);
        return time.format('MM-DD HH:mm');
      }
      return undefined;
    },
  },
  watch: {
    currentDrugInDevice(val) {
      if (val !== undefined || val !== null) {
        this.checkDrugInDevicesIsExpired();
        this.checkLastEvent();
      }
    },
  },
};
</script>

<style lang="sass">
.drug-info--layout
  height: 96%


.drug-table
  display: table
  width: 100%
  height: 100%
  margin: 2%
  
  border-collapse: collapse;
  .drug-table--row, .drug-table--cell, .drug-table--cell-head
    border: 1px solid #dbdbdb

  .drug-table--cell-image
    width: 44%
    margin: 0 2%
.drug-table--row
  display: table-row

.drug-table--cell
  display: table-cell
  padding-left: 10px
  align-items: center
  font-size: 14px
  vertical-align: middle
  
.drug-table--cell-head
  width: 120px

.drug-img--row
  height: 150px

.drug-desc--row
  height: 50px

.modal
  .drug-table--cell-image
    width: 95% !important
    margin: 0 2%

.color-red
  color: red
</style>





// WEBPACK FOOTER //
// DrugInfo.vue?24601407